import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { TopBarSection, TopBarTitle, WidgetContent, TopBar, TextField, Select } from '@duik/it'
import { Link } from 'react-router-dom'
import cls from '../../styles/Header.scss'
import MainContainer from '../../UI/MainContainer'
import TableContainer from '../../UI/TableContainer'
import TableSection from '../../UI/TableSection'
import TableHeader from '../../UI/TableHeader'
import TopBarMenuDivider from '../../UI/TopBarMenuDivider'
import KpiItem from './KpiItem'
import DriverInfoModal from './DriverInfoModal'
import SearchIcon from '@material-ui/icons/SearchOutlined'
import XIcon from '@material-ui/icons/CloseOutlined'
import LoadingIcon from '../../components/LoadingIcon'

import { api } from '../../Controllers/api'

const HaulsKpiTable = props => {
  const [searchValue, setSearchValue] = useState('')
  const [hauls, setHauls] = useState([])
  const [originalHauls, setOriginalHauls] = useState()
  const [projectName, setProjectName] = useState()
  const [selectedHaul, setSelectedHaul] = useState()
  const [showDriverInfoModal, setShowDriverInfoModal] = useState(false)
  const [view, setView] = useState({ value: 'toDate', label: 'To Date' })
  const [loading, setLoading] = useState(true)

  const selectedProject = props.match.params.projectNumber

  useEffect(() => {
    api.get(`dashboard/haulKpiTable/${selectedProject}`).then(({ data }) => {
      setHauls(data)
      setOriginalHauls(data)
      setLoading(false)
    })
  }, []) //eslint-disable-line

  useEffect(() => {
    if (props.projectList) {
      const projectObj = props.projectList.find(
        ({ projectNumber }) => projectNumber === selectedProject
      )
      setProjectName(projectObj.projectName.replace(/\s/g, '\xa0') + '\xa0')
    }
  }, [props.projectList]) //eslint-disable-line

  const search = e => {
    e.preventDefault()
  }

  const clearSearch = () => {
    setSearchValue('')
  }

  const handleDriverInfoModal = (haulId = null) => {
    if (typeof haulId === 'string') {
      setSelectedHaul(originalHauls.find(haul => haul.haulId === haulId))
    } else {
      setSelectedHaul(null)
    }
    setShowDriverInfoModal(!showDriverInfoModal)
  }

  const changeTableView = newView => {
    if (newView === view) {
      return
    } else if (newView.value === 'mostRecent') {
      const mostRecentHauls = originalHauls.map(
        ({ haulId, productionUnits, mostRecentActiveDay, mostRecentActiveDayData }) => {
          if (mostRecentActiveDayData) {
            const { KPIs, haulLogCount } = mostRecentActiveDayData
            mostRecentActiveDay = moment(mostRecentActiveDay).format('MMM-D YYYY')

            return {
              haulId,
              productionUnits,
              KPIs,
              haulLogCount,
              mostRecentActiveDay
            }
          } else {
            return {
              haulId,
              haulLogCount: 0
            }
          }
        }
      )
      setHauls(mostRecentHauls)
    } else setHauls(originalHauls)

    setView(newView)
  }

  return (
    <MainContainer>
      <div style={{ width: '100%' }}>
        <TopBar>
          <TopBarSection>
            <Link to="/app/dashboard" style={{ textDecoration: 'none' }}>
              <h2 className="uik-top-bar-title__wrapper" style={{ paddingLeft: '25px' }}>
                Dashboard
              </h2>
            </Link>
            <h2 className="uik-top-bar-title__wrapper">&nbsp;{'>'}&nbsp;</h2>
            {projectName ? (
              <h2 className="uik-top-bar-title__wrapper" style={{ color: '#289C91' }}>
                {projectName}Hauls
              </h2>
            ) : null}
          </TopBarSection>
          <TopBarSection className={cls.actions}>
            <form className="dashboard-search-margin" onSubmit={e => search(e)}>
              <TextField
                placeholder="Search"
                rightEl={searchValue.length > 0 ? <XIcon onClick={clearSearch} /> : <SearchIcon />}
                onChange={e => setSearchValue(e.target.value)}
                value={searchValue}
                className="halfWidthInputBox"
                wrapperProps={{ style: { marginRight: '10px' } }}
              />
            </form>
          </TopBarSection>
        </TopBar>
      </div>
      <TableContainer>
        <WidgetContent style={{ padding: '8px 0px' }}>
          <TopBarSection style={{ padding: '0px 30px' }}>
            <TopBarTitle>Hauls</TopBarTitle>
            <TopBarMenuDivider />
            {!loading ? (
              <p style={{ fontSize: '0.875rem', color: '#9EA0A5', padding: '0 15px' }}>
                {hauls.length === 1 ? '1 Haul' : `${hauls.length} Hauls`}
              </p>
            ) : (
              <LoadingIcon />
            )}
            <Select
              className="filterSelectRight"
              activeOption={view}
              options={[
                { value: 'toDate', label: 'To Date' },
                {
                  value: 'mostRecent',
                  label: 'Most Recent'
                }
              ]}
              onOptionClick={e => changeTableView(e)}
              position="bottomRight"
            />
          </TopBarSection>
        </WidgetContent>

        <TableSection>
          <thead>
            <tr>
              {[
                'HAUL ID',
                'TIME DRIVING',
                'TIME AT PICK UP',
                'TIME AT DROP OFF',
                'PRODUCTION RATE',
                'TOTAL PRODUCTION',
                ''
              ].map((item, i) => (
                <TableHeader key={i} title={item} />
              ))}
            </tr>
          </thead>
          <tbody>
            {hauls.map(
              ({ haulId, productionUnits, KPIs, haulLogCount, mostRecentActiveDay }, index) => {
                return (
                  <KpiItem
                    projectNumber={selectedProject}
                    haulId={haulId}
                    KPIs={KPIs}
                    productionUnits={productionUnits}
                    haulLogCount={haulLogCount}
                    key={haulId}
                    history={props.history}
                    index={index}
                    mostRecentActiveDay={mostRecentActiveDay}
                    handleDriverInfoModal={handleDriverInfoModal}
                    view={view}
                  />
                )
              }
            )}
          </tbody>
        </TableSection>
      </TableContainer>

      {showDriverInfoModal && (
        <DriverInfoModal haul={selectedHaul} toggleModal={handleDriverInfoModal} />
      )}
    </MainContainer>
  )
}

export default HaulsKpiTable
